import * as React from "react";
import TextField from "@mui/material/TextField";

export default function TextInputField({ value, ...other }) {
  return <TextField value={value} size="small" {...other} />;
}
